import * as React from 'react'
import Navigation from '../../components/Messenger/Navigation'
import BackButton from '../../components/Messenger/Navigation/BackButton'
import { RouteComponentProps } from 'react-router-dom'
import styled, { css } from 'styled-components'
import ConversationBody from '../../components/Messenger/Conversations/ConversationBody'
import ConversationWrapper from '../../components/Messenger/Conversations/ConversationWrapper'
import ConversationMessages from '../../components/Messenger/Conversations/ConversationMessages'
import Loader from '../../components/Loader/Loader'
import ConversationPart from '../../components/Messenger/Conversations/ConversationPart'
import Message from '../../components/Messenger/Conversations/Message'
import TopNavigation from '../../components/Messenger/TopNavigation'
import Container from '../../components/Messenger/Container'
import CloseButton from '../../components/Messenger/Navigation/CloseButton'
import { WithTranslation, withTranslation } from 'react-i18next'
import ConversationsController from '../../controllers/ConversationsController'
import Avatar from '../../components/Messenger/Avatar/Avatar'
import MobilityHelper from '../../../helpers/MobilityHelper'
import { connect } from 'react-redux'
import { AppState } from '../../store'
import { AnyAction, Dispatch } from 'redux'
import { PublicLocale, Widget, Conversation as ConversationType, ConversationMessage, ConversationMessageType, WidgetMessengerEventType, ConversationMessageAuthorType, ConversationChannelEvent, ConversationChannelEventType, ConversationChannelUserTypingEvent, Sounds, ConversationState } from '../../../types'
import Icon from '../../../components/Icons/Icon'
import moment from '../../../utilities/Moment'
import Utils from '../../../utilities/Utils'
import Dropzone from 'react-dropzone'
import { ActiveStorageController } from '../../../controllers'
import EmojiPopover from '../../components/Popover/EmojiPopover'
import GiphyPopover from '../../components/Popover/GiphyPopover'
import Popover from '../../components/Popover/Popover'
import { MessageHelper } from '../../helpers'
import ERoute from '../../ERoute'
import ActionCableConsumer from '../../../consumers/ActionCableConsumer'
import Sound from '../../audio'
import RouteHelper from '../../../helpers/RouteHelper'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  overflow-y: auto;
  flex: 1 1 0%;
`

const Header = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 20px 50px 0px;
  box-sizing: border-box;
  text-align: center;
  line-height: 21px;
  font-weight: normal;
`

const HeaderTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: rgb(0, 0, 0);
  text-align: center;
`

const HeaderDescription = styled.div`
  font-size: 14px;
  text-wrap: wrap;
  color: rgb(115, 115, 115);
`

const Footer = styled.div`
  border-radius: 0px 0px 6px 6px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  padding-bottom: 16px;
  z-index: 3;
  transition: translate 300ms;
  margin-top: -20px;
`

const FooterWrapper = styled.div`
  position: relative;
  min-height: 48px;
  max-height: 158px;
  padding: 0px 20px;
  width: 100%;
`

const InputContainer = styled.div<{ focused: boolean }>`
  position: relative;
  border-radius: 24px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 4px;
  overflow: hidden;
  position: relative;
  outline: rgb(0, 0, 0) solid 0px;
  transition: outline-width 150ms;
  display: flex;
  flex-direction: column;
  transition: all linear 150ms;

  ${props => props.focused && css`
    outline-width: 2px;
  `}
`

const InputWrapper = styled.div`
  position: relative;
  min-height: 35px;
  background-color: white;
  margin-bottom: 2px;

  pre {
    margin: 0;
    font-size: 14px;
    font-weight: normal;
    line-height: 20px;
    max-height: 116px;
    overflow: hidden;
    overflow-wrap: break-word;
    padding: 12px 14px 2px 14px;
    visibility: hidden;
    width: 100%;
    white-space: pre-wrap;
  }

  textarea {
    appearance: none;
    box-sizing: border-box;
    resize: none;
    font-size: 14px;
    font-weight: normal;
    inset: 0px;
    line-height: 20px;
    max-height: 116px;
    outline: none;
    overflow-wrap: break-word;
    padding: 12px 14px 2px 14px;
    position: absolute;
    white-space: pre-wrap;
    width: 100%;
    border: none;
  }
`

const Actions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 14px;
  margin-bottom: 8px;
  gap: 8px;
`

const LeftActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`

const RightActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const Action = styled.div<{ active: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(118, 118, 118);
  cursor: pointer;
  position: relative;
  opacity: 0.8;
  transition: opacity 200ms;
  width: 16px;
  height: 32px;

  ${props => props.active && css`
    color: black;
    opacity: 1;
  `}

  svg {
    width: auto;
    min-width: 16px;
    height: 16px;
    color: currentColor;
  }
`

const Send = styled.div<{ disabled?: boolean }>`
  max-width: 100%;
  box-sizing: border-box;
  padding: 10px 16px;
  position: relative;
  gap: 16px;
  cursor: pointer;
  pointer-events: auto;
  font-size: 14px;
  line-height: 20px;
  color: inherit;
  font-weight: 600;
  white-space: nowrap;
  transition: color 0.2s, background-color 0.2s, box-shadow 0.2s ease-in-out;
  align-items: center;
  border-radius: 32px;
  display: flex;
  justify-content: center;
  height: 32px;
  width: 32px;
  background: rgb(0, 0, 0);
  color: white;

  svg {
    width: auto;
    min-width: 16px;
    height: 16px;
  }

  ${props => props.disabled && css`
    background-color: rgba(9, 14, 21, 0.1);
    color: rgb(214, 214, 214);
    cursor: not-allowed;

    svg {
      fill: currentColor;
    }
  `}
`

const ConversationClosedContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid rgb(235, 235, 235);
  width: 100%;
  background: white;
`

const ConversationClosedMessage = styled.div`
  margin: 24px auto 12px;
  text-align: center;
  font-size: 14px;
  padding-top: 0px;
  line-height: 21px;
  color: rgb(108, 111, 116);
`

interface IStateToProps {
  widget: Widget
  widgetOpen: boolean
  locale: PublicLocale
}

interface IDispatchToProps {
}

type IProps = {} & RouteComponentProps<{ id: string }> & WithTranslation & IStateToProps & IDispatchToProps

interface IState {
  didInitialLoad: boolean
  conversation: ConversationType
  message: string
  sending?: boolean
  emojiPopoverActive: boolean
  giphyPopoverActive: boolean
  inputFocused?: boolean
  userScrolled?: boolean
}

class Conversation extends React.Component<IProps, IState> {
  private TYPING_DELAY = 3000
  private container: React.RefObject<HTMLDivElement> = React.createRef()
  private wrapper: React.RefObject<HTMLDivElement> = React.createRef()
  private messageInput: React.RefObject<HTMLTextAreaElement> = React.createRef()
  private cable: ActionCable.Channel | null = null

  constructor(props: IProps) {
    super(props)

    this.state = {
      didInitialLoad: false,
      conversation: null,
      message: '',
      sending: false,
      emojiPopoverActive: false,
      giphyPopoverActive: false,
      inputFocused: false,
      userScrolled: false
    }

    this.onBackClick = this.onBackClick.bind(this)
    this.focusMessageInput = this.focusMessageInput.bind(this)
    this.onMessageChange = this.onMessageChange.bind(this)
    this.onMessageKeyDown = this.onMessageKeyDown.bind(this)
    this.onMessageInputFocus = this.onMessageInputFocus.bind(this)
    this.onMessageInputBlur = this.onMessageInputBlur.bind(this)
    this.onScroll = Utils.debounce(this.onScroll.bind(this), 150)
    this.onEmojiPopoverToggle = this.onEmojiPopoverToggle.bind(this)
    this.onEmojiPopoverClose = this.onEmojiPopoverClose.bind(this)
    this.onEmojiSelect = this.onEmojiSelect.bind(this)
    this.onGiphyPopoverToggle = this.onGiphyPopoverToggle.bind(this)
    this.onGiphyPopoverClose = this.onGiphyPopoverClose.bind(this)
    this.onGiphySelect = this.onGiphySelect.bind(this)
    this.onAttachmentDrop = this.onAttachmentDrop.bind(this)
    this.onPreviewAttachmentClick = this.onPreviewAttachmentClick.bind(this)
    this.onMessageSendClick = this.onMessageSendClick.bind(this)
    this.sendMessage = this.sendMessage.bind(this)
    this.scrollToEnd = this.scrollToEnd.bind(this)
    this.markConversationAsRead = Utils.debounce(this.markConversationAsRead.bind(this), 250, true)

    // Action cable
    this.onActionCableConnected = this.onActionCableConnected.bind(this)
    this.onActionCableDisconnected = this.onActionCableDisconnected.bind(this)
    this.onActionCableReceived = this.onActionCableReceived.bind(this)
    this.onActionCableSubscriptionInitialised = this.onActionCableSubscriptionInitialised.bind(this)
    this.sendTypingEvent = this.sendTypingEvent.bind(this)
  }

  async fetchConversation() {
    try {
      const { conversation } = await ConversationsController.getView(this.props.match.params.id)

      this.setState({
        didInitialLoad: true,
        conversation: conversation,
        userScrolled: false,
      }, () => {
        setTimeout(this.scrollToEnd, 500)
      })
    } catch (ex) {
      console.error(ex)
    }
  }

  markConversationAsRead() {
    const { conversation } = this.state
    const { widgetOpen } = this.props

    if (widgetOpen && conversation?.id && !conversation.user_read) {
      try {
        ConversationsController.read(conversation.id).catch(console.error)
        this.setState({ conversation: { ...conversation, user_read: true } })
      } catch (ex) {
        console.error(ex)
      }
    }
  }

  componentDidMount(): void {
    this.fetchConversation().catch(console.error)
  }

  componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any): void {
    const { conversation } = this.state

    if (conversation?.id && !conversation?.user_read) this.markConversationAsRead()
  }

  onBackClick() {
    this.props.history.replace(ERoute.PATH_CONVERSATIONS)
  }

  focusMessageInput() {
    if (this.messageInput.current) this.messageInput.current.focus()
  }

  onMessageChange(e) {
    this.setState({ message: e.target.value })
  }

  onMessageKeyDown(e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      this.onMessageSendClick()
    }
  }

  onMessageInputFocus() {
    this.sendTypingEvent(true)
    this.setState({ inputFocused: true })
  }

  onMessageInputBlur() {
    this.sendTypingEvent(false, true)
    this.setState({ inputFocused: false })
  }

  onScroll() {
    if (!this.wrapper.current) return

    const { scrollTop, scrollHeight, clientHeight } = this.wrapper.current
    const userScrolled = scrollTop + clientHeight < scrollHeight - 50

    this.setState({ userScrolled: userScrolled })
  }

  onEmojiPopoverToggle() {
    this.setState({ emojiPopoverActive: !this.state.emojiPopoverActive })
  }

  onEmojiPopoverClose() {
    this.setState({ emojiPopoverActive: false })
  }

  onEmojiSelect(emoji: any) {
    const { message } = this.state

    this.setState({
      emojiPopoverActive: false,
      message: [message, emoji.native].join(' ').trim()
    }, this.focusMessageInput)
  }

  onGiphyPopoverToggle() {
    this.setState({ giphyPopoverActive: !this.state.giphyPopoverActive })
  }

  onGiphyPopoverClose() {
    this.setState({ giphyPopoverActive: false })
  }

  onGiphySelect(url: string) {
    this.setState({ giphyPopoverActive: false }, this.focusMessageInput)

    this.sendMessage({
      type: ConversationMessageType.GIF,
      url: url
    })
  }

  async onAttachmentDrop(acceptedFiles: File[]) {
    const acceptedFile = acceptedFiles[0]

    try {
      const blob = await ActiveStorageController.uploadMessengerPromise(acceptedFile)

      const reader = new FileReader()
      const attachmentUrl = await new Promise<string>((resolve, reject) => {
        reader.onload = () => resolve(reader.result as string)
        reader.onerror = reject
        reader.readAsDataURL(acceptedFile)
      })

      this.sendMessage({
        type: ConversationMessageType.ATTACHMENT,
        attachment: blob.signed_id,
        attachment_file_name: acceptedFile.name,
        attachment_content_type: acceptedFile.type,
        attachment_file_size: acceptedFile.size,
        attachment_url: attachmentUrl
      })
    } catch (ex) {
      console.error(ex)
    }
  }

  onPreviewAttachmentClick(url: string) {
    MessageHelper.sendMessage({
      type: WidgetMessengerEventType.PREVIEW_ATTACHMENT,
      url: url
    })
  }

  async onMessageSendClick() {
    const { message, sending } = this.state
    if (message.length === 0 || sending) return

    const conversationMessage: ConversationMessage = {
      type: ConversationMessageType.TEXT,
      content: message,
    }

    this.sendMessage(conversationMessage).catch(console.error)
  }

  async sendMessage(message: ConversationMessage) {
    let { conversation } = this.state

    const conversationMessage: ConversationMessage = {
      ...message,
      client_assigned_id: Utils.uuid(),
      author: {
        type: ConversationMessageAuthorType.CONTACT,
      },
    }

    try {
      this.setState({
        conversation: {
          ...conversation,
          messages: [...(conversation?.messages || []), conversationMessage]
        },
        message: ''
      }, this.scrollToEnd)

      Sound.play(Sounds.SUBMIT)

      if (conversation.id) {
        const updatedConversation = await ConversationsController.reply(conversation.id, conversationMessage)
        this.setState({ conversation: updatedConversation })
      } else {
        this.setState({ sending: true })
        const newConversation = await ConversationsController.create(conversationMessage)
        this.setState({ conversation: newConversation })
        this.props.history.replace(RouteHelper.process(ERoute.PATH_CONVERSATION, { id: newConversation.id }))
      }
    } catch (ex) {
      console.error(ex)
    } finally {
      this.sendTypingEvent(false, true)
      this.setState({ sending: false })
    }
  }

  scrollToEnd(behaviour: ScrollBehavior = 'smooth') {
    if (this.state.userScrolled) return

    requestAnimationFrame(() => {
      if (this.wrapper.current) {
        this.wrapper.current.scrollTo({
          top: this.wrapper.current.scrollHeight,
          behavior: behaviour
        })
      }
    })
  }

  getMessagesGroupedByDate(): { [date: string]: ConversationMessage[] } {
    const { conversation } = this.state
    if (!conversation || !conversation.messages) {
      return {}
    }

    const messagesByDate = conversation
      .messages
      .filter(message => ![ConversationMessageType.NOTE].includes(message.type))
      .reduce((acc, message) => {
        const date = moment(message.created_at).format('YYYY-MM-DD')
        if (!acc[date]) acc[date] = []
        acc[date].push(message)
        return acc
      }, {})

    return messagesByDate
  }

  onActionCableConnected() {
    console.log('[ConversationChannel] connected')
  }

  onActionCableDisconnected() {
    console.log('[ConversationChannel] Disconnected')
  }

  onActionCableReceived(event: ConversationChannelEvent) {
    const { conversation } = this.state
    console.log('[ConversationChannel] received event', event)

    switch (event.type) {
      case ConversationChannelEventType.CONVERSATION_CREATE:
        this.setState({ conversation: event.data.conversation }, this.scrollToEnd)
        break
      case ConversationChannelEventType.CONVERSATION_UPDATE:
        this.setState({ conversation: event.data.conversation }, this.scrollToEnd)
        break
      case ConversationChannelEventType.CONVERSATION_DELETE:
        this.props.history.goBack()
        break
      case ConversationChannelEventType.ADMIN_TYPING:
        const { typing } = event.data

        if (typing) {
          if (conversation?.messages?.some(message => message.type === ConversationMessageType.TYPING)) return

          const typingMessage: ConversationMessage = {
            type: ConversationMessageType.TYPING,
            client_assigned_id: Utils.uuid(),
          }

          this.setState({
            conversation: {
              ...conversation,
              messages: [...(conversation?.messages || []), typingMessage]
            }
          }, this.scrollToEnd)
        } else {
          const messages = conversation?.messages || []
          this.setState({
            conversation: {
              ...conversation,
              messages: messages.filter(message => message.type !== ConversationMessageType.TYPING)
            }
          }, this.scrollToEnd)
        }
        break
    }
  }

  onActionCableSubscriptionInitialised(cable: ActionCable.Channel) {
    this.cable = cable
  }

  sendTypingEvent(typing: boolean, delayed: boolean = false) {
    setTimeout(() => {
      const event: ConversationChannelUserTypingEvent = {
        type: ConversationChannelEventType.USER_TYPING,
        data: { typing: typing }
      }
      this.cable?.send(event)
    }, delayed ? this.TYPING_DELAY : 0)
  }

  render() {
    const { t, widget, locale } = this.props
    const {
      didInitialLoad,
      conversation,
      message,
      sending,
      emojiPopoverActive,
      giphyPopoverActive,
      inputFocused
    } = this.state

    const groupedMessages = this.getMessagesGroupedByDate()

    return (
      <Container ref={this.container}>
        <TopNavigation />

        <Navigation
          left={didInitialLoad && <BackButton onClick={this.onBackClick} />}
          title={didInitialLoad ? 'Conversation' : ''}
          right={<CloseButton />}
        />
        {!didInitialLoad && <Loader />}
        {didInitialLoad && <ActionCableConsumer
          channel={{ channel: 'ConversationChannel', id: conversation.id }}
          onConnected={this.onActionCableConnected}
          onDisconnected={this.onActionCableDisconnected}
          onReceived={this.onActionCableReceived}
          subscriptionHandler={this.onActionCableSubscriptionInitialised}
        >
          <Wrapper ref={this.wrapper} onScroll={this.onScroll}>
            <Header>
              {widget.agents?.length > 0 && widget.agents.slice(0, 1).map((agent) => (
                <Avatar
                  name={agent.name}
                  key={agent.id}
                  width={64}
                  src={agent.avatar_url}
                  rounded
                />
              ))}

              <HeaderTitle>{t('ConversationHeader::We typically reply within a day')}</HeaderTitle>

              <HeaderDescription>
                {MobilityHelper.getTranslation(locale, widget.translations, 'user_welcome_message')}
              </HeaderDescription>
            </Header>

            <ConversationBody>
              <ConversationWrapper>
                <ConversationMessages>
                  {Object.keys(groupedMessages).map((date, index) => {
                    const messages = groupedMessages[date]

                    return (
                      <>
                        <ConversationPart key={date} type='date'>
                          {moment(date).format('MMMM D')}
                        </ConversationPart>

                        {messages?.map((message, index) => {
                          const previousMessage = messages[index - 1]
                          const nextMessage = messages[index + 1]

                          const topRadius = previousMessage && previousMessage?.author?.type === message.author?.type
                          const bottomRadius = nextMessage && nextMessage?.author?.type === message.author?.type

                          return (
                            <ConversationPart key={message.id || message.client_assigned_id} type='message'>
                              <Message
                                message={message}
                                onPreviewClick={this.onPreviewAttachmentClick}
                                admin={false}
                                topRadius={topRadius}
                                bottomRadius={bottomRadius}
                                locale={locale}
                              />
                            </ConversationPart>
                          )
                        })}
                      </>
                    )
                  })}
                </ConversationMessages>
              </ConversationWrapper>
            </ConversationBody>

          </Wrapper>
          <Footer>
            {!(conversation.state === ConversationState.CLOSED) && <FooterWrapper>

              <InputContainer focused={inputFocused || emojiPopoverActive || giphyPopoverActive}>
                <InputWrapper>
                  <pre>{message}</pre>
                  <textarea
                    ref={this.messageInput}
                    placeholder={t('Conversation::Message...')}
                    onChange={this.onMessageChange}
                    value={message}
                    onKeyDown={this.onMessageKeyDown}
                    onFocus={this.onMessageInputFocus}
                    onBlur={this.onMessageInputBlur}
                  />
                </InputWrapper>
                <Actions>
                  <LeftActions>
                    <Popover
                      active={emojiPopoverActive}
                      activator={<Action onClick={this.onEmojiPopoverToggle} active={emojiPopoverActive}>
                        <Icon icon='messenger-emoji' />
                      </Action>}
                      onClose={this.onEmojiPopoverClose}
                      placement='top'
                      strategy='fixed'
                      container={this.container.current}
                    >
                      <EmojiPopover
                        onEmojiSelect={this.onEmojiSelect}
                      />
                    </Popover>

                    {message.length === 0 && <>
                      <Popover
                        active={giphyPopoverActive}
                        activator={<Action onClick={this.onGiphyPopoverToggle} active={giphyPopoverActive}>
                          <Icon icon='messenger-gif' />
                        </Action>}
                        onClose={this.onGiphyPopoverClose}
                        placement='top'
                        strategy='fixed'
                        container={this.container.current}
                      >
                        <GiphyPopover onGifSelect={this.onGiphySelect} />
                      </Popover>

                      <Dropzone
                        onDrop={this.onAttachmentDrop}
                        maxSize={20000000}
                        maxFiles={1}
                      >
                        {({ getRootProps, getInputProps }) => (
                          <Action {...getRootProps()}>
                            <input {...getInputProps()} />
                            <Icon icon='messenger-attachment' />
                          </Action>
                        )}
                      </Dropzone>
                    </>}
                  </LeftActions>

                  <RightActions>
                    <Send onClick={this.onMessageSendClick} disabled={message.length === 0 || sending}>
                      <Icon icon='messenger-arrow-up' />
                    </Send>
                  </RightActions>
                </Actions>
              </InputContainer>
            </FooterWrapper>}

            {conversation.state === ConversationState.CLOSED && <ConversationClosedContainer>
              <ConversationClosedMessage>{t('Conversation::Your conversation has ended')}</ConversationClosedMessage>
            </ConversationClosedContainer>}
          </Footer>
        </ActionCableConsumer>}
      </Container>
    )
  }
}

const mapStateToProps = (state: AppState): IStateToProps => {
  const {
    application: {
      widget,
      locale,
      open,
    }
  } = state

  return {
    widget: widget,
    widgetOpen: open,
    locale: locale
  }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): IDispatchToProps => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Conversation))